export const onScrollEnd = (action) => {
    const layout = document.querySelector(".layout");
    const contentHeight = layout.offsetHeight;
    const yOffset = layout.scrollHeight - layout.scrollTop;

    if (yOffset - 5 <= contentHeight) {
        action();
    }
};